export default __webpack_public_path__ + "./img/tooltip-info.ee6fbf719217f0d07dc95aaad73ff5e5.png";